export default {
  submit: '提交',
  reset: '重置',
};
